export const photos = [
  {
    original: 'https://404.com/404.png',
    thumbnail: 'https://404.com/404.png',
  }
];
